import { useTranslation } from 'react-i18next';
import {
    Chip,
    Grid,
    Button,
    IconButton,
} from '@material-ui/core';
import { Icon as MdiIcon } from '@mdi/react';
import { mdiClipboardOutline } from '@mdi/js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import './EmployeeBidProfileHeader.scss';
// eslint-disable-next-line import/no-unresolved
import { EmployeeRank } from '@commonClient/components';
import { GroupedIconButton } from '../../../components';
import {
    UkgDateFormat,
    BidProfileStatus,
} from '../../../Enums';
import DateFormatService from '../../../services/DateFormatService';
import { getProfileStatusLabel } from '../../../Enums/Helpers/LabellingHelper';
import { getProfileStatusColor } from '../../../Enums/Helpers/StylingHelper';

/**
 * @param {{
 * handleBack: () => void
 * title: string
 * statusId?: BidProfileStatus,
 * requestPeriodStartDate: Date
 * requestPeriodEndDate: Date
 * submissionPeriodStartDate: Date
 * submissionPeriodEndDate: Date
 * isForeverRequestPeriod: boolean
 * employeeSubmissionDate: Date
 * reportOptions?: import("../../../components/GroupedIconButton/GroupedIconButton").GroupedIconButtonOption[]
 * handleEditSelection?: () => void
 * employeeRank?: EmployeeBidProfile.IRankedEmployee
 * userInitials?: string | null
 * }} param0
 */
function EmployeeBidProfileHeader({
    handleBack = () => { },
    title = '',
    statusId,
    requestPeriodStartDate,
    requestPeriodEndDate,
    submissionPeriodStartDate,
    submissionPeriodEndDate,
    isForeverRequestPeriod,
    employeeSubmissionDate,
    reportOptions,
    handleEditSelection = () => { },
    employeeRank,
    userInitials,
}) {
    const { t } = useTranslation('shiftBidding');

    return (
        <>
            <Grid
                container
                className="ebph-selection-topbar"
            >
                <Grid
                    item
                    xs={10}
                    lg={10}
                    className="header-properties-container"
                >
                    <Grid
                        container
                        className="header-properties-line-container"
                    >
                        <Grid
                            item
                        >
                            <Grid
                                container
                            >
                                <Grid
                                    item
                                    lg={3}
                                >
                                    <div
                                        className="header-title-container"
                                    >
                                        <IconButton
                                            className="header-icon-button"
                                            onClick={() => handleBack()}
                                        >
                                            <FontAwesomeIcon icon={faArrowLeft} />
                                        </IconButton>
                                        <p className="headline-h-700 ebph-bid-name">
                                            {title}
                                        </p>
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    lg={3}
                                    className="header-status-container"
                                >
                                    <Chip
                                        label={getProfileStatusLabel(statusId)}
                                        variant="outlined"
                                        style={getProfileStatusColor(statusId)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                        >
                            <Grid
                                container
                            >
                                <Grid
                                    item
                                    lg={3}
                                >
                                    <span className="header-property-label">Request period: </span>
                                    <span className="header-property-value">
                                        {`${DateFormatService.formatDateOrEmpty(requestPeriodStartDate, UkgDateFormat.LongDate)} 
                                - ${(isForeverRequestPeriod ? t('employee.anytime') : DateFormatService.formatDateOrEmpty(requestPeriodEndDate, UkgDateFormat.LongDate))}`}
                                    </span>
                                </Grid>
                                <Grid
                                    item
                                    lg={3}
                                >
                                    <span className="header-property-label">Submission start date: </span>
                                    <span className="header-property-value">
                                        {DateFormatService.formatDateOrEmpty(submissionPeriodStartDate, UkgDateFormat.LongDateTime)}
                                    </span>
                                </Grid>
                                <Grid
                                    item
                                    lg={3}
                                >
                                    <span className="header-property-label">Submission end date: </span>
                                    <span className="header-property-value">
                                        {DateFormatService.formatDateOrEmpty(submissionPeriodEndDate, UkgDateFormat.LongDateTime)}
                                    </span>
                                </Grid>
                                {
                                    employeeSubmissionDate
                                        ? (
                                            <Grid
                                                item
                                                lg={2}
                                            >
                                                <span className="header-property-label">Submitted at: </span>
                                                <span className="header-property-value">
                                                    {DateFormatService.formatDateOrEmpty(employeeSubmissionDate, UkgDateFormat.LongDateTime)}
                                                </span>
                                            </Grid>
                                        ) : null
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    item
                    xs={2}
                    lg={2}
                >
                    <Grid
                        container
                        spacing={0}
                        justifyContent="flex-end"
                        alignItems="center"
                        className="buttons-container"
                    >
                        {
                            !!(reportOptions.length) && (
                                <Grid
                                    item
                                    className="ebph-report-button"
                                >
                                    <GroupedIconButton
                                        icon={(
                                            <MdiIcon
                                                path={mdiClipboardOutline}
                                                size={1}
                                            />
                                        )}
                                        buttonClassName="ebph-report-button"
                                        tooltipTitle={t('common.reports.reports')}
                                        options={reportOptions}
                                    />
                                </Grid>
                            )
                        }
                        {
                            statusId !== null
                            && ![BidProfileStatus.Closed, BidProfileStatus.Published, BidProfileStatus.Canceled].includes(statusId)
                            && (
                                <Grid
                                    item
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => handleEditSelection()}
                                    >
                                        Edit Selection
                                    </Button>
                                </Grid>
                            )
                        }
                        {
                            employeeRank && (
                                <Grid item>
                                    <EmployeeRank
                                        label="Rank"
                                        rank={employeeRank?.rank}
                                        avatar={userInitials || ''}
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default EmployeeBidProfileHeader;
